@if (!missingData) {
  <div class="st-drawer-wrapper">
    <a href=""></a>
    <div class="st-drawer-header">
      <span class="text-header-16 text-semibold">{{(nzData.editingElement ? 'Editar' : 'Crear') + ' ' + nzData.maestroName}}</span>
      <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
    </div>

    <form [formGroup]="dynamicForm" class="st-drawer-content st-form" nz-form>
      @for (column of nzData.columnsData; track column) {
        <div>
          <!--Este if es para oculltar columnas en el drawer-->
          @if (column.pathData!.name !== 'id' && column.noVisibleInForm!==false) {
            <div>
              @switch (column.pathData!.type || 'text') {

                <!-- Input de texto -->
                @case ('text') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                        <input type="text" nzSize="large" nz-input [formControlName]="column.pathData!.name" />
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Input numérico -->
                @case ('number') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                        <input type="number" nzSize="large" nz-input [formControlName]="column.pathData!.name" />
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Selector de fecha -->
                @case ('date') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{ column.name }}</nz-form-label>
                      <nz-form-control>
                        <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                          <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100"
                                          [formControlName]="column.pathData!.name"
                                          nzFormat="dd-MM-yyyy"
                          ></nz-date-picker>
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Selector dropdown -->
                @case ('select') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                        <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                                   nzShowSearch [formControlName]="column.pathData!.name">
                          @for (opt of column.optionList; track opt) {
                            <nz-option [nzValue]="opt.id" [nzLabel]="opt.name || opt.role">
                            </nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Selector avatar -->
                @case ('avatar-select') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                        <app-avatar-select [formControlName]="column.pathData!.name"
                                           [options]="getPartnerOptions(column)"
                        ></app-avatar-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }
                <!-- Selector icon -->
                @case ('icon-select') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                        <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                                   [formControlName]="column.pathData!.name"
                                   nzPlaceHolder="Selecciona el Icono..." [nzDropdownStyle]="{width: '264px'}"
                                   nzDropdownClassName="grid-dropdown" [nzOptionOverflowSize]="43"
                                   [nzDropdownMatchSelectWidth]="false" [nzCustomTemplate]="iconSelectTpmpl">
                          @for (icon of column.optionList; track icon) {
                            <nz-option [nzLabel]="icon" [nzValue]="icon" nzCustomContent>
                              <button nz-button nzShape="circle" class="text-btn-16 flex-center" nzType="text" style="color: inherit">
                                <app-st-icon [name]="icon"></app-st-icon>
                              </button>
                            </nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Selector booleano -->
                @case ('boolean') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                        <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                                   nzShowSearch [formControlName]="column.pathData!.name">
                          <nz-option [nzValue]=true [nzLabel]="'Si'">
                          </nz-option>
                          <nz-option [nzValue]=false [nzLabel]="'No'">
                          </nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }

                <!-- Selector dropdown multi-select-->
                @case ('multi-select') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                        <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                                   class="custom-select" nzMode="multiple" nzShowSearch [formControlName]="column.pathData!.name"
                                   [compareWith]="compareFn">
                          @for (opt of  column.optionList!; track opt) {
                            <nz-option [nzValue]="opt" [nzLabel]="opt.name">
                            </nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }


                <!-- Input de imagen -->
                @case ('image') {
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzRequired>{{ column.name }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                        <input type="hidden" nzSize="large" nz-input [formControlName]="column.pathData!.name" />
                        <nz-upload #uploadComponent nzType="drag"
                          [nzShowUploadList]="false"
                          [nzMultiple]="false"
                          [nzCustomRequest]="customUpload"
                          (nzChange)="handleUploadChange($event,column)"
                          nzAccept="image/*">
                          @if (!avatarUrl) {
                           <div class="ant-upload-drag-icon">
                            <app-st-icon [bold]="true" name="upload"></app-st-icon>
                          </div>
                          <!-- <nz-icon class="upload-icon" [nzType]="loading ? 'loading' : 'plus'" /> -->
                            <!-- <div class="ant-upload-text">Upload</div> -->
                          } @else {
                          <img [src]="avatarUrl" class="avatar-uploader"/>
                          }

                          <!-- <p class="ant-upload-text">{{ (isMobile$ | async) ? 'Pulsa para subir la imagen.' : 'Arrastra a esta ventana o haz
                            click para subir la imagen.' }}</p> -->
                        </nz-upload>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                }


              }
  </div>
          }
        </div>
      }
    </form>

    <div class="st-drawer-footer">
      <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar</button>
      <button [disabled]="!dynamicForm.valid || loading" (click)="onSubmit()"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        @if (!loading) {
          <app-st-icon class="prefix" [name]="nzData.editingElement ? 'edit' : 'add'" [bold]="true"></app-st-icon>
        }
        @if (loading) {
          <app-st-icon class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        }
        <span>{{nzData.editingElement ? 'Guardar' : 'Crear'}}</span>
      </button>
    </div>
  </div>
} @else {
  <h3>No se puede crear/editar datos de este maestro porque no se tienen datos para configurar la propiedad {{missingData}}.
    Por favor llena la tabla correspondiente.</h3>
}

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>

<ng-template #iconSelectTpmpl let-selected>
  <app-st-icon [name]="selected.nzValue"></app-st-icon>
</ng-template>
